<template lang="pug">
  .pagination-area
    p
      | Foram encontrad{{ gender }}s {{ total }} {{ object }}
      br
      | Exibindo de {{ ((pageAtual-1) * perPage) + 1 }} até {{ ((pageAtual-1) * perPage) + perPageAtual }}
    nav(aria-label="Paginação")
      pagination(
        :totalPage="totalPage",
        customActiveBGColor="#00607D",
        prevText="<"
        nextText=">"
        :currentPage="pageAtual"
        @btnClick="goToFunction")
</template>

<style lang="scss">
  .pagination-area {
    margin: 40px auto;
    text-align: center;

    .pagination {
      > li:not(.active) > a { color: $text-default-color; }
    }
  }
</style>

<script>
  import Pagination from 'vue-paginate-al'
  export default {
    name: 'paginacao',

    props: {
      gender: { type: String, required: true },
      object: { type: String, required: true },
      total: { type: Number, required: true },
      totalPage: { type: Number, required: true },
      perPageAtual: { type: Number, required: true },
      perPage: { type: Number, required: false }
    },

    data () {
      return {
        pageAtual: 1
      }
    },

    components: {
      Pagination
    },

    methods: {
      goToFunction: function (n) {
        this.pageAtual = n
        this.$router.push({ params: { page: this.pageAtual } })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Paginacao.vue?f3cadc82